module.exports = __webpack_public_path__ + "b789c54f71a1b9f7aa958a936402bc0f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/quarantaene.jpg
// module id = 777
// module chunks = 0